// FIXME: typescript enum
angular.module('capability-ng-scheduler').constant(
  'PreferenceTypeEnum',
  Enumeration('PreferenceTypeEnum', {
    COMMITMENT: {
      id: 'commitment',
      unit: 'Hrs Committed'
    },
    CAMPUS_LOCATION: {
      id: 'campus_location',
      unit: 'Locations Selected'
    },
    BUSY_TIME: {
      id: 'busy_time',
      unit: 'Busy Times Added'
    },
    COURSE_LENGTH: {
      id: 'course_length',
      unit: 'Lengths Chosen'
    }
  })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/components/campus_location/types/preference_type_enum.js